module.exports = __webpack_public_path__ + "img/innovator-entrepreneur-3.3ae21cea.svg";